var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      staticClass: "dropdown-listed dropdown-projects",
      attrs: {
        "aria-role": "menu",
        "mobile-modal": false,
        disabled: _vm.disabled,
      },
      on: { "active-change": _vm.addFocus },
    },
    [
      _c(
        "a",
        {
          class: [
            "button",
            _vm.isCancel ? "is-cancel" : "is-cancel is-outlined",
          ],
          style: _vm.triggerStyle ? _vm.triggerStyle.a : null,
          attrs: { slot: "trigger" },
          slot: "trigger",
        },
        [
          _vm.selectedValue
            ? [
                _c(
                  "span",
                  {
                    staticClass: "code tag mr5-xs",
                    style: _vm.triggerStyle ? _vm.triggerStyle.code : null,
                  },
                  [
                    _vm._v(
                      "\n                " + _vm._s(_vm.code) + "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "name" }, [_vm._v(_vm._s(_vm.name))]),
              ]
            : [_c("span", { staticClass: "name" }, [_vm._v(_vm._s(_vm.name))])],
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "icon angle-down" },
            [
              _c("font-awesome-icon", {
                attrs: { icon: ["fas", "angle-down"] },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        { attrs: { "aria-role": "menu-item", custom: "" } },
        [
          _c("textInput", {
            ref: "search",
            attrs: { type: "SEARCH" },
            on: { input: _vm.doSearch },
            model: {
              value: _vm.searchTerm,
              callback: function ($$v) {
                _vm.searchTerm = $$v
              },
              expression: "searchTerm",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isSearching
        ? [
            _c("div", { staticClass: "head" }, [
              _vm.count
                ? _c("span", { staticClass: "mr5-xs" }, [
                    _vm._v(_vm._s(_vm.count)),
                  ])
                : _vm._e(),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("searchResults")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _vm.isLoading
              ? _c(
                  "b-dropdown-item",
                  {
                    staticClass: "is-info",
                    attrs: { "aria-role": "menu-item" },
                  },
                  [_c("loader", { attrs: { text: _vm.$t("searching") } })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.data && _vm.data.length == 0 && !_vm.isLoading
              ? _c(
                  "b-dropdown-item",
                  {
                    staticClass: "is-info",
                    attrs: { "aria-role": "menu-item" },
                  },
                  [_vm._v(_vm._s(_vm.$t("noProjectsFound")))]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.data && _vm.data.length > 0
        ? [
            _vm._l(_vm.data, function (item, index) {
              return _c(
                "b-dropdown-item",
                {
                  key: index,
                  attrs: { "aria-role": "menu-item", "has-link": "" },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onClick(item)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "tag mr5-xs",
                          style: `background-color:${_vm.stringToHslColor({
                            str: item.name,
                          })};color:#fff;`,
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.code) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(item.name) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _c("pagination", {
              attrs: { count: _vm.count, hidePerPage: true },
              model: {
                value: _vm.pagination,
                callback: function ($$v) {
                  _vm.pagination = $$v
                },
                expression: "pagination",
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isSearching && _vm.recentItems.length > 0
        ? [
            _c("div", { staticClass: "head" }, [
              _vm._v(_vm._s(_vm.$t("recentProjects"))),
            ]),
            _vm._v(" "),
            _vm._l(_vm.recentItems, function (item, index) {
              return _c(
                "b-dropdown-item",
                {
                  key: index,
                  attrs: { "aria-role": "menu-item", "has-link": "" },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onClick(item)
                        },
                      },
                    },
                    [
                      item.meta.code
                        ? _c(
                            "span",
                            {
                              staticClass: "tag mr5-xs",
                              style: `background-color:${_vm.stringToHslColor({
                                str: item.meta.title,
                              })};color:#fff;`,
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(item.meta.code) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.meta ? [_vm._v(_vm._s(item.meta.title))] : _vm._e(),
                    ],
                    2
                  ),
                ]
              )
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedValue
        ? [
            _c("hr", {
              staticClass: "dropdown-divider",
              attrs: { "aria-role": "menuitem" },
            }),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { "aria-role": "menu-item" }, on: { click: _vm.clear } },
              [
                _c(
                  "span",
                  { staticClass: "icon" },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "times"] },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", [_vm._v(" " + _vm._s(_vm.$t(this.label)) + " ")]),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }